module.exports = __webpack_public_path__ + "static/media/sword-laser-alt.832fafbf.svg";